import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const expert = {
  fetchExperts: lazyModuleMethod(() => import('./fetchExperts'), 'default'),
  fetchExpert: lazyModuleMethod(() => import('./fetchExpert'), 'default'),
  updateExpert: lazyModuleMethod(() => import('./updateExpert'), 'default'),
  createExpert: lazyModuleMethod(() => import('./createExpert'), 'default'),
  deleteExpert: lazyModuleMethod(() => import('./deleteExpert'), 'default'),
}
